import { render } from "./SkilupSideSliderComponent.vue?vue&type=template&id=b1cd6c9e&ts=true"
import script from "./SkilupSideSliderComponent.vue?vue&type=script&lang=ts"
export * from "./SkilupSideSliderComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__